var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-contact"},[_c('footer',{staticClass:"pt-4"},[_c('h5',{staticClass:"text-center pt-3 text-white"},[_vm._v("Copyright CredMap ©"+_vm._s(new Date().getFullYear())+" All Rights Reserved.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }